// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7DveQ","message":"styles_message__f-e1m","add-contact-btn":"styles_add-contact-btn__VJ0RP"};